import pageTitle from "@/src/data/pageTitles";
import { Body, Title } from "@/lib/main";
import { Link } from "react-router";

export default function ErrorFallback() {
  return (
    <>
      <title>{pageTitle("error")}</title>
      <Title>Error</Title>
      <Body>
        An error has occured. Please go to the <Link to="/">homepage</Link>. If
        the link does not work, please try again later.
      </Body>
    </>
  );
}
